import { render, staticRenderFns } from "./Table-aseguradora.vue?vue&type=template&id=2a0f4406&"
import script from "./Table-aseguradora.vue?vue&type=script&lang=js&"
export * from "./Table-aseguradora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports